import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, IonInput, useIonAlert, IonButtons, IonButton, IonItemGroup, IonItemDivider, IonDatetimeButton, IonCheckbox, IonTextarea, IonModal, IonDatetime, IonSegment, IonSegmentButton, IonIcon, IonLoading, IonSpinner, IonSelect, IonSelectOption } from '@ionic/react';
import { useEffect, useRef, useState } from 'react';
import './ClientEditor.css';
import { useHistory, useParams } from 'react-router';
import { getClient, addClient, removeClient } from '../firebase/clients';
import dateFormat from 'dateformat';
import { callOutline, chatboxOutline, checkmark, checkmarkCircleOutline, chevronBack, helpCircle } from 'ionicons/icons';
import { getCurrentUser } from '../firebase/firebase';
import ClientCommentsList from './ClientCommentsList';
import { cleanupClientComments } from '../firebase/clientComments';
import { getSmsTemplates } from '../firebase/smsTemplates';
import { getUser } from '../firebase/users';
import Permissions from './Permissions';
import ClientEventsViewer from './ClientEventsViewer';
const axios = require(`axios`)

export function hideTabs() {
  const tabsEl = document.querySelector('ion-tab-bar');
  if (tabsEl) {
    tabsEl.hidden = true;
  }
}

export function showTabs() {
  const tabsEl = document.querySelector('ion-tab-bar');
  if (tabsEl) {
    tabsEl.hidden = false;
  }
}

function isValidPesel(pesel: string) {
  if (typeof pesel !== 'string')
    return false;

  let weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
  let sum = 0;
  let controlNumber = parseInt(pesel.substring(10, 11));

  for (let i = 0; i < weight.length; i++) {
    sum += (parseInt(pesel.substring(i, i + 1)) * weight[i]);
  }
  sum = sum % 10;
  return (10 - sum) % 10 === controlNumber;
}

function getInt(pesel: string, index: number) {
  return parseInt(pesel.charAt(index))
}
function getDateFromPesel(pesel: string) {
  var rok = 1900 + getInt(pesel, 0) * 10 + getInt(pesel, 1);
  if (getInt(pesel, 2) >= 2 && getInt(pesel, 2) < 8)
    rok += Math.floor(getInt(pesel, 2) / 2) * 100;
  if (getInt(pesel, 2) >= 8)
    rok -= 100;

  var miesiac = (getInt(pesel, 2) % 2) * 10 + getInt(pesel, 3);
  var dzien = getInt(pesel, 4) * 10 + getInt(pesel, 5);
  var r = rok + "-";
  if (miesiac < 10) {
    r += "0";
  }
  r += miesiac + "-";
  if (dzien < 10) {
    r += "0";
  }
  r += dzien;
  return r;
}

const ClientEditor: React.FC = () => {

  const [busy, setBusy] = useState(false);
  const params: any = useParams();
  const history = useHistory();
  var initData: any = {};
  if (params.id !== undefined && params.id !== 0) {
    initData = getClient(params.id);
    if (initData === undefined) {
      initData = {};
    }
  }
  const [presentAlert2] = useIonAlert();

  useEffect(() => {
    if (params.id !== undefined && params.id !== 0) {
      hideTabs();
      return () => {
        cleanupClientComments();
        showTabs();
      }
    }
  }, []);


  function getPermission(){
    return 'write';
    // if(getCurrentUser().role === 'manager'){
    //   return 'write';
    // }
    // if(initData.id === null || initData.id === undefined){
    //   return 'write';
    // }
    // let currentUserId = getCurrentUser().id;
    // if(initData.userId === currentUserId){
    //   return 'write';
    // }
    // if(initData.permissions[currentUserId] !== undefined && initData.permissions[currentUserId] !== null){
    //   return initData.permissions[currentUserId];
    // }
    // return 'none';
  }

  const [tab, setTab] = useState('DataTab');
  const [presentAlert] = useIonAlert();

  const [title, setTitle] = useState(initData.name === undefined ? "Nowy" : initData.surname + " " + initData.name);


  const [name, setName] = useState(initData.name === undefined ? "" : initData.name);
  const [surname, setSurname] = useState(initData.surname === undefined ? "" : initData.surname);
  const [email, setEmail] = useState(initData.email === undefined ? "" : initData.email);
  const [phone, setPhone] = useState(initData.phone === undefined ? "" : initData.phone);
  const [smsTemplate, setSmsTemplate] = useState(initData.smsTemplate === undefined ? "" : initData.smsTemplate);
  const [address, setAddress] = useState(initData.address === undefined ? "" : initData.address);
  const [zipCode, setZipCode] = useState(initData.zipCode === undefined ? "" : initData.zipCode);
  const [city, setCity] = useState(initData.city === undefined ? "" : initData.city);
  const [active, setActive] = useState(initData.active === undefined ? "" : initData.active);
  const [birthday, setBirthday] = useState(initData.birthday === undefined ? "2000-01-01" : initData.birthday);
  const [pesel, setPesel] = useState(initData.pesel === undefined ? "" : initData.pesel);

  const [gname, setgName] = useState(initData.gname === undefined ? "" : initData.gname);
  const [gsurname, setgSurname] = useState(initData.gsurname === undefined ? "" : initData.gsurname);
  const [gemail, setgEmail] = useState(initData.gemail === undefined ? "" : initData.gemail);
  const [gphone, setgPhone] = useState(initData.gphone === undefined ? "" : initData.gphone);
  const [gsmsTemplate, setgSmsTemplate] = useState(initData.gsmsTemplate === undefined ? "" : initData.gsmsTemplate);
  const [gaddress, setgAddress] = useState(initData.gaddress === undefined ? "" : initData.gaddress);
  const [gzipCode, setgZipCode] = useState(initData.gzipCode === undefined ? "" : initData.gzipCode);
  const [gcity, setgCity] = useState(initData.gcity === undefined ? "" : initData.gcity);

  const [iname, setiName] = useState(initData.iname === undefined ? "" : initData.iname);
  const [iaddress, setiAddress] = useState(initData.iaddress === undefined ? "" : initData.iaddress);
  const [izipCode, setiZipCode] = useState(initData.izipCode === undefined ? "" : initData.izipCode);
  const [icity, setiCity] = useState(initData.icity === undefined ? "" : initData.icity);
  const [icountry, setiCountry] = useState(initData.icountry === undefined ? "" : initData.icountry);
  const [ivat, setiVat] = useState(initData.ivat === undefined ? "" : initData.ivat);

  const [comments, setComments] = useState(initData.comments === undefined ? "" : initData.comments);

  const [birthdayPlace, setBirthdayPlace] = useState(initData.birthdayPlace === undefined ? "" : initData.birthdayPlace);
  const [school, setSchool] = useState(initData.school === undefined ? "" : initData.school);
  const [schoolClass, setSchoolClass] = useState(initData.schoolClass === undefined ? "" : initData.schoolClass);


  async function confirm() {
    if (pesel.length > 0) {
      if (!isValidPesel(pesel)) {
        presentAlert({
          header: 'Niepoprawny numer PESEL!',
          buttons: [
            {
              text: 'Usuń',
              role: 'confirm',
            },
          ],
        });
        return;
      }
    }
    var returnData: {
      id: string | null, name: any, surname: any, email: any, phone: any, active: boolean, birthday: any, address: any, zipCode: any, city: any, smsTemplate: any,
      gname: any, gsurname: any, gemail: any, gphone: any, gaddress: any, gzipCode: any, gcity: any, gsmsTemplate: any
      comments: any, pesel: string,
      iname: any, iaddress: any, izipCode: any, icity: any, icountry: any, ivat: any,
      commentList: [], birthdayPlace: any, school: any, schoolClass: any,
      created: any, updated: any,
    } = {
      id: null,
      name: '',
      surname: '',
      email: '',
      phone: '',
      smsTemplate: '',
      active: true,
      birthday: '',
      pesel: '',
      address: '',
      zipCode: '',
      city: '',

      gname: '',
      gsurname: '',
      gemail: '',
      gphone: '',
      gsmsTemplate: '',
      gaddress: '',
      gzipCode: '',
      gcity: '',

      comments: '',

      iname: '',
      iaddress: '',
      izipCode: '',
      icity: '',
      icountry: '',
      ivat: '',

      commentList: [],

      birthdayPlace: '',
      school: '',
      schoolClass: '',

      created: '',
      updated: ''

    };
    if (initData.id !== undefined && initData.id !== 0) {
      returnData.id = initData.id;
    }
    returnData.name = name;
    returnData.surname = surname;
    returnData.email = email;
    returnData.phone = phone.replace(/\D/g,'');
    returnData.smsTemplate = smsTemplate;
    returnData.active = active;
    if (pesel.length > 0) {
      returnData.birthday = getDateFromPesel(pesel);
    } else {
      returnData.birthday = birthday;
    }
    returnData.pesel = pesel;
    returnData.address = address;
    returnData.zipCode = zipCode;
    returnData.city = city;

    returnData.birthdayPlace = birthdayPlace;
    returnData.school = school;
    returnData.schoolClass = schoolClass;



    returnData.gname = gname;
    returnData.gsurname = gsurname;
    returnData.gemail = gemail;
    returnData.gphone = gphone.replace(/\D/g,'');;
    returnData.gsmsTemplate = gsmsTemplate;
    returnData.gaddress = gaddress;
    returnData.gzipCode = gzipCode;
    returnData.gcity = gcity;

    returnData.iname = iname;
    returnData.iaddress = iaddress;
    returnData.izipCode = izipCode;
    returnData.icity = icity;
    returnData.icountry = icountry;
    returnData.ivat = ivat;

    returnData.commentList = initData.commentList;

    returnData.comments = comments;

    returnData.created = initData.created;
    returnData.updated = initData.updated;
    setBusy(true);
    if (await addClient(returnData)) {
      history.goBack();
    }
    setBusy(false);

  }

  function remove() {
    presentAlert({
      header: 'Usuwanie!',
      buttons: [
        {
          text: 'Anuluj',
          role: 'cancel'
        },
        {
          text: 'Usuń',
          role: 'confirm',
        },
      ],
      onDidDismiss: async (e: CustomEvent) => {
        if (e.detail.role === 'confirm') {
          setBusy(true);
          if (await removeClient(params.id)) {
            history.goBack();
          }
          setBusy(false)
        }
      },
    })

  }

  function cancel() {
    history.goBack();
  }

  function getPhoneNumberForSms(str: string) {
    if (str.length >= 9) {
      if (/^\d+$/.test(str)) {
        if (str.length === 9) {
          str = "0048" + str;
        }
        if (str.length === 11) {
          str = "00" + str;
        }
        return str;
      }
    }
    return undefined;

  }

  function newSms(n:string){
    var  number = getPhoneNumberForSms(n);
          if (number !== undefined) {
            history.push("/app/smses/" + number)
          } else {
            presentAlert2({
              header: 'Niepoprawny nr telefonu!',
              buttons: [
                {
                  text: 'OK'
                },
              ],
            })
          }
  }

  const templates = getSmsTemplates();


  const DataTab = <div><IonItemGroup className="ion-padding">
    <IonItemDivider>
      <IonLabel>
        Pacjent
      </IonLabel>
    </IonItemDivider>
    <IonItem>
      <IonLabel>Nazwisko</IonLabel>
      <IonInput slot="end" value={surname} placeholder="nazwisko" onIonChange={(e) => { setSurname(e.detail.value); setTitle(e.detail.value + " " + name); }} />
    </IonItem>
    <IonItem>
      <IonLabel>Imię</IonLabel>
      <IonInput slot="end" value={name} placeholder="imię" onIonChange={(e) => { setName(e.detail.value); setTitle(surname + " " + e.detail.value); }} />
    </IonItem>
    <IonItem>
      <IonLabel>Email</IonLabel>
      <IonInput value={email} placeholder="email" onIonChange={(e) => { setEmail(e.detail.value) }} />
    </IonItem>
    <IonItem>
      <IonLabel>Telefon</IonLabel>
      <IonInput slot="end" value={phone} placeholder="telefon" onIonChange={(e) => { setPhone(e.detail.value) }} />
      <a slot="end" href={"tel:" + phone}><IonIcon icon={callOutline}  /></a>
      <a slot="end" ><IonIcon icon={chatboxOutline} onClick={() => { newSms(phone) }} /></a>
    </IonItem>
    <IonItem>
      <IonLabel>Szablon</IonLabel>
      <IonSelect style={{ maxWidth: "100%" }} interface="popover" value={smsTemplate} onIonChange={(e) => { setSmsTemplate(e.detail.value) }} placeholder="Wybierz szablon SMS">
        <IonSelectOption key={undefined} value={undefined}>{undefined}</IonSelectOption>
        {templates.map(t => {
          return <IonSelectOption key={t.id} value={t.id}>{t.topic}</IonSelectOption>
        })}
      </IonSelect>
    </IonItem>

    <IonItem>
      <IonLabel>Adres</IonLabel>
      <IonInput slot="end" value={address} placeholder="adres" onIonChange={(e) => { setAddress(e.detail.value) }} />
    </IonItem>
    <IonItem>
      <IonLabel>Kod</IonLabel>
      <IonInput slot="end" value={zipCode} placeholder="kod" onIonChange={(e) => { setZipCode(e.detail.value) }} />
    </IonItem>
    <IonItem>
      <IonLabel>Poczta</IonLabel>
      <IonInput slot="end" value={city} placeholder="poczta" onIonChange={(e) => { setCity(e.detail.value) }} />
    </IonItem>
    <IonItem>
      <IonLabel>Pesel</IonLabel>
      <IonInput slot="end" value={pesel} placeholder="pesel" onIonChange={(e) => { setPesel(e.detail.value) }} />
    </IonItem>
    <IonItem>
      <IonLabel>Data urodzenia</IonLabel>
      <IonDatetimeButton slot="end" datetime="clientDate"></IonDatetimeButton>
    </IonItem>
    <IonItem>
      <IonLabel>Miejsce urodzenia</IonLabel>
      <IonInput slot="end" value={birthdayPlace} placeholder="miejsce urodzenia" onIonChange={(e) => { setBirthdayPlace(e.detail.value) }} />
    </IonItem>
    <IonItem>
      <IonLabel>Szkoła</IonLabel>
      <IonInput slot="end" value={school} placeholder="szkoła" onIonChange={(e) => { setSchool(e.detail.value) }} />
    </IonItem>
    <IonItem>
      <IonLabel>Klasa</IonLabel>
      <IonInput slot="end" value={schoolClass} placeholder="klasa" onIonChange={(e) => { setSchoolClass(e.detail.value) }} />
    </IonItem>
    <IonItem>
      <IonLabel>Aktywny</IonLabel>
      <IonCheckbox slot="end" checked={active} onIonChange={(e) => { setActive(e.detail.checked) }}></IonCheckbox>
    </IonItem>
    <IonItem>
      <IonLabel position="stacked">Uwagi</IonLabel>
      <IonTextarea placeholder="uwagi" autoGrow={true} value={comments} onIonChange={(e) => { setComments(e.detail.value) }}></IonTextarea>
    </IonItem>
  </IonItemGroup>

    <IonItemGroup className="ion-padding">
      <IonItemDivider>
        <IonLabel>
          Opiekun
        </IonLabel>
      </IonItemDivider>
      <IonItem>
        <IonLabel>Nazwisko</IonLabel>
        <IonInput slot="end" value={gsurname} placeholder="nazwisko" onIonChange={(e) => { setgSurname(e.detail.value) }} />
      </IonItem>
      <IonItem>
        <IonLabel>Imię</IonLabel>
        <IonInput slot="end" value={gname} placeholder="imię" onIonChange={(e) => { setgName(e.detail.value) }} />
      </IonItem>
      <IonItem>
        <IonLabel>Email</IonLabel>
        <IonInput slot="end" value={gemail} placeholder="email" onIonChange={(e) => { setgEmail(e.detail.value) }} />
      </IonItem>

      <IonItem>
        <IonLabel>Telefon</IonLabel>
        <IonInput slot="end" value={gphone} placeholder="telefon" onIonChange={(e) => { setgPhone(e.detail.value) }} />
        <a slot="end" href={"tel:" + gphone}><IonIcon icon={callOutline} /></a>
        <a slot="end" ><IonIcon icon={chatboxOutline} onClick={() => { newSms(gphone) }} /></a>
      </IonItem>
      <IonItem>
        <IonLabel>Szablon</IonLabel>
        <IonSelect style={{ maxWidth: "100%" }} interface="popover" value={gsmsTemplate} onIonChange={(e) => { setgSmsTemplate(e.detail.value) }} placeholder="Wybierz szablon SMS">
          <IonSelectOption key={undefined} value={undefined}>{undefined}</IonSelectOption>
          {templates.map(t => {
            return <IonSelectOption key={t.id} value={t.id}>{t.topic}</IonSelectOption>
          })}
        </IonSelect>
      </IonItem>

      <IonItem>
        <IonLabel>Adres</IonLabel>
        <IonInput slot="end" value={gaddress} placeholder="adres" onIonChange={(e) => { setgAddress(e.detail.value) }} />
      </IonItem>
      <IonItem>
        <IonLabel>Kod</IonLabel>
        <IonInput slot="end" value={gzipCode} placeholder="kod" onIonChange={(e) => { setgZipCode(e.detail.value) }} />
      </IonItem>
      <IonItem>
        <IonLabel>Poczta</IonLabel>
        <IonInput slot="end" value={gcity} placeholder="miejscowość" onIonChange={(e) => { setgCity(e.detail.value) }} />
      </IonItem>
    </IonItemGroup>
    <IonItemGroup className="ion-padding">
      <IonItemDivider>
        <IonLabel>
          Dane do faktury
        </IonLabel>
      </IonItemDivider>
      <IonItem>
        <IonLabel>Nazwa</IonLabel>
        <IonInput slot="end" value={iname} placeholder="nazwa firmy" onIonChange={(e) => { setiName(e.detail.value) }} />
      </IonItem>
      <IonItem>
        <IonLabel>Adres</IonLabel>
        <IonInput slot="end" value={iaddress} placeholder="adres" onIonChange={(e) => { setiAddress(e.detail.value) }} />
      </IonItem>
      <IonItem>
        <IonLabel>Kod</IonLabel>
        <IonInput slot="end" value={izipCode} placeholder="kod" onIonChange={(e) => { setiZipCode(e.detail.value) }} />
      </IonItem>
      <IonItem>
        <IonLabel>Poczta</IonLabel>
        <IonInput slot="end" value={icity} placeholder="miejscowość" onIonChange={(e) => { setiCity(e.detail.value) }} />
      </IonItem>
      <IonItem>
        <IonLabel>Kraj</IonLabel>
        <IonInput slot="end" value={icountry} placeholder="kraj" onIonChange={(e) => { setiCountry(e.detail.value) }} />
      </IonItem>
      <IonItem>
        <IonLabel>NIP</IonLabel>
        <IonInput slot="end" value={ivat} placeholder="nip" onIonChange={(e) => { setiVat(e.detail.value) }} />
      </IonItem>
    </IonItemGroup>
    <IonItemGroup className="ion-padding">
      <IonItemDivider>
        <IonLabel>
          Dodatkowe
        </IonLabel>
      </IonItemDivider>
        <IonItem>
            <IonLabel>Utworzył</IonLabel>
            <IonLabel>{initData.userId !== undefined && initData.userId !== null ? getUser(initData.userId).surname +" "+getUser(initData.userId).name :'' }</IonLabel>
          </IonItem>
        <IonItem>
          <IonLabel>Utworzono</IonLabel>
          <IonLabel>{initData.created !== undefined && initData.created !== null ? dateFormat(initData.created.toDate(), "yyyy-mm-dd HH:MM") : ''}</IonLabel>
        </IonItem>
        <IonItem>
          <IonLabel>Zmodyfikowano</IonLabel>
          <IonLabel>{initData.updated !== undefined && initData.updated !== null ? dateFormat(initData.updated.toDate(), "yyyy-mm-dd HH:MM"): ''}</IonLabel>
        </IonItem>
      </IonItemGroup>

    {initData.id !== undefined && initData.name === '' && initData.surname === '' ?
      <IonItemGroup className="ion-padding" >
        <IonButton expand="block" color="danger" onClick={() => remove()}>usuń</IonButton>
      </IonItemGroup>
      : ""}
  </div>;







  const content = useRef<HTMLIonContentElement>(null);

  if (tab === "SmsTab") {
    if (content.current !== null) {
      content.current.scrollToBottom(0);
    }
  }
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton color="medium" onClick={() => cancel()}>
              <IonIcon icon={chevronBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>{title}</IonTitle>
          {getPermission()==='write' ? 
          <IonButtons slot="end">
            <IonButton onClick={() => confirm()}><IonIcon icon={checkmark} /></IonButton>
          </IonButtons>:''}
          
        </IonToolbar>
        <IonSegment value={tab} onIonChange={(v) => { setTab(v.detail.value ?? 'DataTab') }}>
          <IonSegmentButton value="DataTab">
            <IonLabel>Dane</IonLabel>
          </IonSegmentButton>
          {getCurrentUser().role === 'manager' || initData.userId === getCurrentUser().id ? 
          <IonSegmentButton value="PermissionsTab">
            <IonLabel>Uprawnienia</IonLabel>
          </IonSegmentButton>
          : ''}
          
          {initData.id !== undefined ?
          <IonSegmentButton value="CommentsTab">
            <IonLabel>Dokumenty</IonLabel>
          </IonSegmentButton>
          :''}
          
          {initData.id !== undefined ?
          <IonSegmentButton value="EventsTab">
            <IonLabel>Wizyty</IonLabel>
          </IonSegmentButton>
          :''}

        </IonSegment>
      </IonHeader>
      {/* <IonLoading message="" duration={0} isOpen={busy} ></IonLoading> */}

      <IonLoading duration={0} isOpen={busy} />
      <IonContent ref={content}>


        <div style={{ maxWidth: "800px" }}>
          {tab === "DataTab" ? DataTab : ''}
          {tab === "PermissionsTab" ? <Permissions collection='clients' id={initData.id} permissions={initData.permissions} updateDate={initData.updated}  db={true} goBackAfterSave={false}/> : ''}
          {tab === "CommentsTab" ? <ClientCommentsList clientId={initData.id} /> : ''}
          {tab === "EventsTab" ? <ClientEventsViewer clientId={initData.id} /> : ''}
          
        </div>
      </IonContent>

      <IonModal keepContentsMounted={true}>
        <IonDatetime id="clientDate" value={birthday} presentation="date" onIonChange={(e) => { setBirthday(e.detail.value) }}></IonDatetime>
      </IonModal>
    </IonPage>
  );
};

export default ClientEditor;
